export const shadows = {
  cardRest:
    "0px 0px 0px 1px rgba(0, 0, 0, 0.08), 0px 2px 4px 0px rgba(0, 0, 0, 0.16)",
  elementRestNoBorder: "0px 2px 4px 0px rgba(0, 0, 0, 0.04)",
}
